import React from "react";
import PropTypes from "prop-types";
import { Typography, Table } from "antd";
const { Title } = Typography;
const TasksTables = ({ pendingTasks, inProgressTasks, taskColumns, inProgressColumns }) => (
  <>
    {pendingTasks.length > 0 && (
      <>
        <Title level={4}>Pending Tasks:</Title>
        <Table dataSource={pendingTasks} columns={taskColumns} rowKey="id" pagination={false} />
        <hr />
      </>
    )}
    {inProgressTasks.length > 0 && (
      <>
        <Title level={4} style={{ marginTop: 20 }}>
          My Tasks:
        </Title>
        <Table
          dataSource={inProgressTasks}
          columns={inProgressColumns}
          rowKey="id"
          pagination
          bordered
        />
        <hr />
      </>
    )}
  </>
);
TasksTables.propTypes = {
  pendingTasks: PropTypes.arrayOf(PropTypes.object).isRequired,
  inProgressTasks: PropTypes.arrayOf(PropTypes.object).isRequired,
  taskColumns: PropTypes.arrayOf(PropTypes.object).isRequired,
  inProgressColumns: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default TasksTables;
